import { GET_ALL_TAGS, GET_ALL_TAGS_SUCCEEDED } from "./types";

export const getAllTags = (payload) => ({
    type: GET_ALL_TAGS,
    payload
});

export const getAllTagsSucceeded = (payload) => ({
   type: GET_ALL_TAGS_SUCCEEDED,
   payload
});




// WEBPACK FOOTER //
// ./src/SHARED/actions/tags.actions.js